import styled from '@emotion/styled'

import { getCSSObjectFromStyleProps } from '../styleProps/StylePropsService'

export const Box = styled.div(
  {
    boxSizing: 'border-box',
  },
  getCSSObjectFromStyleProps,
)
